import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getGenerationSalesPlanMasterFormOptions } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetGenerationSalesPlanMasterFormOptionsRequestSchema,
  type GetGenerationSalesPlanMasterFormOptionsResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 発電販売計画マスタ form 選択肢を集約 RPC で取得する hook。
 *
 * BFF が発電区分でフィルタ済みの submitters / bgs を返す。
 * cache key は RPC 定義のみ (area param は持たない、area narrow は client-side)。
 */
export function useGetGenerationSalesPlanMasterFormOptions(): UseQueryResult<
  GetGenerationSalesPlanMasterFormOptionsResponse,
  ConnectError
> {
  return useQuery(
    getGenerationSalesPlanMasterFormOptions,
    create(GetGenerationSalesPlanMasterFormOptionsRequestSchema, {}),
  )
}
